export default function Kontaktieren() {
    return <h1>Kontaktieren</h1>
} 